export default "__VITE_ASSET__BXSyquvX__"